import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "@/lib/analytics";
import { initSentry } from "@/lib/sentry";
import { installApiBaseFetchInterceptor } from "@/lib/apiBase";

// Install the API base URL fetch interceptor BEFORE any module that
// might fire a request (analytics, Sentry transport, marketing form
// submissions, the pricing-page Stripe checkout) so the rewrite is in
// place for the very first /api/… call. No-op when VITE_API_BASE_URL
// is not set.
installApiBaseFetchInterceptor();

// Initialize Sentry before the React tree renders so any error during
// the very first render is captured.
initSentry();
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
